import React from "react";
// import useEducation from "../hooks/useEducation";

// components
import UpdateEducation from "./UpdateEducation";

// state and types
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { FcGraduationCap } from "react-icons/fc";
import { IoMdTrash } from "react-icons/io";
import { get_month_and_year } from "../../../services/formatter/date";
import { IEducation } from "../../../store/types/auth";
import { delete_education } from "../../../services/api/education";

const Education: React.FC = () => {
  const dispatch = useAppDispatch();
  const educations = useAppSelector(({ education }) => education.educations);
  const [show, showSet] = React.useState<boolean>(false);
  const [edu, eduSet] = React.useState<IEducation | null>(null);

  return (
    <div className="py-0 mb-3 font-abel">
      {educations?.map((item, index) => (
        <div
          key={index + 1}
          className={`capitalize relative bg-[#F5F5F5] px-5 py-3 rounded-md shadow-md ${
            index === 0 ? "mb-2" : "my-2"
          }`}
        >
          <div className="">
            {item.highest === 1 ? (
              <FcGraduationCap size={25} className="absolute -top-2 right-0" />
            ) : (
              ""
            )}
            <div className="flex justify-between items-center">
              <p className="font-bold">{item?.college?.name}</p>
              <div className="flex items-center gap-3">
                <p
                  onClick={() => {
                    showSet(true);
                    eduSet(item);
                  }}
                  className="cursor-pointer font-bold text-[#243677]"
                >
                  Edit
                </p>
                <IoMdTrash
                  size={20}
                  className="cursor-pointer text-red-500 hover:text-red-700"
                  onClick={() => {
                    if (item.id) {
                      delete_education(dispatch, item.id.toString());
                    }
                  }}
                />
              </div>
            </div>
            <p className="my-[3px]">
              {item?.major?.name + ","} {item?.degree?.name}
            </p>
            <p className="my-[3px]">
              {item?.graduation
                ? get_month_and_year(item.graduation)
                : "Current"}
            </p>
          </div>
        </div>
      ))}

      {show && (
        <UpdateEducation
          education={edu}
          onDone={() => {
            showSet(false);
            eduSet(null);
          }}
        />
      )}

      <div className="text-[#243677]">
        {!show && (
          <button
            type="button"
            className="border-none "
            onClick={() => showSet(true)}
          >
            + Add education
          </button>
        )}
      </div>
    </div>
  );
};

export default Education;
